import "./index.css";
import App from "./App";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { Provider, ErrorBoundary } from "@rollbar/react";

const rollbarConfig = {
  accessToken: "eef331c0cc0d496594e023fbfcf8d085",
  environment: import.meta.env.MODE,
  enabled: import.meta.env.MODE !== "development",
  captureUncaught: true,
  captureUnhandledRejections: true,
  verbose: true, 
  payload: {
    environment: import.meta.env.MODE,
    client: {
      javascript: {
        source_map_enabled: true, 
        code_version: import.meta.env.VITE_APP_VERSION || "unknown",
        guess_uncaught_frames: true,
      },
    },
  },

};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const app = (
  <Provider config={rollbarConfig}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>
);

root.render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
